import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { StyledButton } from '../../../../globalStyled';
import { ReactComponent as DiscordLogo } from '../../../../assets/img/discord-logo.svg';

export const DiscordLogoIcon = styled(DiscordLogo)`
  width: 72px;
  height: auto;
  cursor: pointer;
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 12;
  width: 100%;
  padding: 0 16px 0 12px;
  height: ${({ theme }) => theme.headerHeight};
  min-height: ${({ theme }) => theme.headerHeight};
  background: ${({ theme }) => theme.header};
  color: ${({ theme }) => theme.headerText};
  box-shadow: none;
  @media screen and (max-width: 1199px) {
    padding: 0 6px 0 12px;
  }
`;

export const StyledDesktopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;
  @media screen and (max-width: 1199px) {
    display: none;
  }
`;

export const StyledMobileBar = styled.div`
  display: none;
  @media screen and (max-width: 1199px) {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-width: 0;
  }
`;

export const StyledBrand = styled(NavLink)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 16px;
  text-decoration: none;
  color: ${({ theme }) => theme.headerText};
  min-width: 0;
  img {
    display: block;
    height: 26px;
    width: auto;
    max-width: min(240px, 42vw);
    object-fit: contain;
    flex-shrink: 0;
    filter: brightness(0) invert(1);
  }
  @media screen and (max-width: 1199px) {
    margin-right: 8px;
    img {
      height: 20px;
      max-width: 96px;
    }
  }
`;

export const StyledHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  justify-content: flex-end;
  gap: 10px;
`;

export const StyledHeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
  gap: 14px;
  position: relative;
  z-index: 2;
  @media screen and (max-width: 1199px) {
    flex-shrink: 1;
    min-width: 0;
  }
`;

export const StyledCrestLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  background: transparent;
  span {
    font-family: 'Archivo', sans-serif;
    font-size: 11px;
    font-weight: 700;
    color: ${({ theme }) => theme.headerText};
  }
  img {
    width: 36px;
    height: 36px;
    object-fit: contain;
  }
`;

export const StyledTeamName = styled.p`
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Archivo', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.15;
  color: ${({ theme }) => theme.headerText};
`;

export const StyledTeamBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0;
  gap: 16px;
  @media screen and (max-width: 1199px) {
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 3px;
  }
`;

export const StyledMetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.headerAccent};
  @media screen and (max-width: 1199px) {
    gap: 8px;
    min-width: 0;
    max-width: 100%;
    flex-shrink: 1;
  }
`;

export const StyledMetaIcon = styled.span`
  display: grid;
  place-items: center;
  place-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ theme }) => theme.headerAccent};
  color: ${({ theme }) => theme.header};
  flex-shrink: 0;
  font-size: 0;
  line-height: 0;
  svg {
    display: block;
    width: 12px;
    height: 12px;
    max-width: 12px;
    max-height: 12px;
    fill: none;
    stroke: currentColor;
  }
`;

export const StyledMetaLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: ${({ theme }) => theme.headerAccent};
  text-decoration: none;
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1;
  white-space: nowrap;
  @media screen and (max-width: 1199px) {
    font-size: 11px;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &[data-negative='true'] {
    color: ${({ theme }) => theme.danger};
    ${StyledMetaIcon} {
      background: ${({ theme }) => theme.danger};
    }
  }
`;

export const StyledDropdownTrigger = styled(StyledButton)`
  border: 0;
  background: transparent;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  min-width: 36px;
  z-index: 2;
  position: relative;
  padding: 0;
  margin: 0;
  overflow: hidden;
  img {
    width: 36px;
    height: 36px;
    object-fit: cover;
  }
`;

export const StyledDiscordTrigger = styled(StyledButton)`
  border: 0;
  background: transparent;
  height: 36px;
  min-width: 0;
  padding: 0 4px;
  margin: 0;
`;

export const StyledAvatar = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
`;

export const StyledDropdownWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const StyledDropdownContainer = styled.div`
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  border: 1px solid ${({ theme }) => theme.border};
  position: fixed;
  top: ${({ theme }) => theme.headerHeight};
  right: 10px;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  width: 280px;
  z-index: 3;
  overflow: hidden;
`;
